import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { actions as modalActions } from '@wix/da-shared-react/pkg/Modals';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { getCurrentUserHasCore } from '@wix/da-shared-react/pkg/publicSession/selectors';
import {
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
} from '../../../selectors/users';
import { isSectionLoading } from '../../../selectors/sections';
import { AppState } from '../../../../types/store';
import { Props } from './SubscriptionsSection';
import {
  hasPublishedTiers,
  hasTiers,
} from '../../../selectors/subscriptionsSection';

type StateProps = Pick<
  Props,
  | 'profileOwnerUser'
  | 'isOwner'
  | 'hasTiers'
  | 'hasPublishedTiers'
  | 'hasCore'
  | 'isSectionLoading'
>;
type DispatchProps = Pick<Props, 'openTierModal'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  return {
    isOwner: isCurrentUserProfileOwner(state),
    hasTiers: hasTiers(state),
    hasPublishedTiers: hasPublishedTiers(state),
    hasCore: getCurrentUserHasCore(state),
    isSectionLoading: isSectionLoading(state),
    profileOwnerUser: getProfileOwnerUser(state),
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  openTierModal: () =>
    modalActions.pushModal(ModalType.TIER_EDIT, {
      wrapInModal: false,
    }),
};

export default connect(mapStateToProps, mapDispatchToProps);
